import MaterialTable from 'material-table';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@material-ui/core';
import moment from 'moment';
import apiService from '../../../services.js/apiService';

const MobileAppVersionList = () => {
  const [pageSize] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState('');
  const history = useHistory();
  const pageOptions = [5, 10, 15, 20, 25];
  const tableRef = React.createRef();

  const handleOpenModal = (modalId) => {
    setOpenModal(true);
    setId(modalId);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onClickDelete = async (e) => {
    e.preventDefault();
    try {
      await apiService.deleteMobileAppVersion(id);

      toast.success('Delete mobile app version Success');
      tableRef.current.onQueryChange();
    } catch (err) {
      toast.error('Delete mobile app version failed');
    }
    handleCloseModal();
  };

  const fetchData = async (query) => {
    try {
      let orderBy = 'createdAt';
      let orderDirection = 'DESC';
      let versionName;
      if (query.orderBy) {
        orderBy = query.orderBy.field;
        orderDirection = query.orderDirection;
      }

      if (query.search) {
        versionName = query.search;
      }

      if (query.pageSize !== pageSize) {
        query.page = 0;
      }

      const { rows, totalCount } = await apiService.getMobileAppVersions({ pageNo: query.page, pageSize: query.pageSize, orderBy, orderDirection, versionName });
      return { rows, totalCount };
    } catch (err) {
      toast.error('Fetch mobile app version data failed');
      return { rows: [], totalCount: 0 };
    }
  };

  return (
    <div>
      <div className="content-header d-flex align-items-center py-3">
        <Typography variant="h4" style={{ fontWeight: 'bold' }}>Mobile App Version List</Typography>
        <Link to="/admin/mobileApp/mobileAppVersion/add">
          <Button variant="contained">Add</Button>
        </Link>
      </div>

      <MaterialTable
        tableRef={tableRef}
        data={(query) => new Promise((resolve) => {
          try {
            if (query.pageSize !== pageSize) {
              query.page = 0;
            }

            fetchData(query).then((result) => {
              resolve({
                data:       result.rows,
                page:       query.page,
                pageSize,
                totalCount: result.totalCount,
              });
            });
          } catch (err) {
            toast.error(err);
            resolve({
              data:       [],
              page:       0,
              totalCount: 0,
            });
          }
        })}
        columns={[
          { title: 'Version Name', field: 'versionName' },
          { title: 'Version Type', field: 'versionType' },
          { title: 'Upload Status', field: 'uploadStatus' },
          { title:  'Created At',
            field:  'createdAt',
            render: (row) => (row.createdAt !== null ? `${moment(row.createdAt).format('D MMM YYYY')}` : '-'),
          },
        ]}
        actions={[
          {
            icon:    'edit',
            tooltip: 'View/Edit Post',
            onClick: (event, mobileAppVersion) => {
              history.push(`/admin/mobileApp/mobileAppVersion/${mobileAppVersion.id}`);
            },
          },
          {
            icon:    'delete',
            tooltip: 'Delete Post',
            onClick: (event, mobileAppVersion) => {
              handleOpenModal(mobileAppVersion.id);
            },
          },
        ]}
        localization={{ toolbar: { searchPlaceholder: 'Search version name' } }}
        options={{
          actionsColumnIndex:  -1,
          search:              true,
          showTitle:           false,
          sorting:             true,
          paging:              true,
          emptyRowsWhenPaging: false,
          pageSize,
          pageSizeOptions:     pageOptions,
        }}
      />
      <Dialog
        fullWidth
        size="sm"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Mobile App Version</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this version?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">Cancel</Button>
          <Button onClick={(e) => { onClickDelete(e); }} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>
    </div>

  );
};

export default connect(null, null)(MobileAppVersionList);
